import "@hotwired/turbo-rails";

import "../controllers";
import "../pwa_install";

import AOS from "aos";
window.AOS = AOS;
AOS.init();

// to close dialog when visit another page
// so it does not open when back to the page
document.addEventListener("turbo:visit", () => {
  const elements = document.querySelectorAll('[data-dialog-open-value="true"]');
  elements.forEach((element) => {
    element.dataset.dialogOpenValue = "false";
  });
});

// Service Worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service_worker.js")
    .then((registration) => {
      registration.addEventListener("updatefound", () => {
        // If updatefound is fired, it means that there's
        // a new service worker being installed.
        const installingWorker = registration.installing;
        console.log(
          "A new service worker is being installed:",
          installingWorker,
        );

        // You can listen for changes to the installing service worker's
        // state via installingWorker.onstatechange
      });
    })
    .catch((error) => {
      console.error(`Service worker registration failed: ${error}`);
    });
} else {
  console.error("Service workers are not supported.");
}
